import { loadPaymentHistory, isOfficeOpen } from './services'
import { getSystem } from './account.module'

const getDefaultState = () => {
  return {
    receipts: null,
    isOffice: null
  }
}

const state = getDefaultState()

const getters = {
  getReceipts: (state) => {
    return state.receipts ? state.receipts : null
  },
  getSummary: (state) => {
    return state.receipts && state.receipts.summary ? state.receipts.summary : null
  },
  getOfficeInfo: (state) => {
    return state.isOffice ? state.isOffice : null
  }
}

const actions = {
  async loadReceiptsAction  ({ commit, rootState }) {
    const booking = rootState.booking.booking
    const isOfficeData = await isOfficeOpen()
    commit('officeDataReceived', isOfficeData)

    if (!booking || !booking.booking_information) {
      return
    }

    const res = await loadPaymentHistory(booking.booking_information.lead_surname, booking.user_information.bookingNumber, booking.booking_information.branch_number, booking.booking_information.source, getSystem(booking.booking_information), booking.booking_information.fil)
    if (res.error === false) {
      if (res.data && res.data.receipts) {
        const receipts = res.data.receipts
        commit('receiptsReceived', receipts)
      }
    }
  },
  resetStateAction ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  receiptsReceived (state, receipts) {
    state.receipts = receipts
  },
  officeDataReceived (state, data) {
    state.isOffice = data
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}
